import { ButtonGroup } from '@mui/material';
import styled from 'styled-components';

export const UndoRedoButtonGroup = styled(ButtonGroup)`
    background-color: ${({ theme }) => theme.palette.grey.bg2};
    box-shadow: 0 0 20px 20px ${({ theme }) => theme.palette.grey.bg2};
`;
